import React from 'react';
import { useTranslation } from 'react-i18next';

const milestones = [
    { year: '2022', color: 'orange',  side: 'right', titleKey: 'theIdea',            descKey: 'theIdeaDesc' },
    { year: '2023', color: 'blue',    side: 'left',  titleKey: 'businessConception', descKey: 'businessConceptionDesc' },
    { year: '2024', color: 'green',   side: 'right', titleKey: 'legalSetup',         descKey: 'legalSetupDesc' },
    { year: '2025', color: 'purple',  side: 'left',  titleKey: 'growth',            descKey: 'growthDesc' },
];

const StoryBlog = () => {
    const { t } = useTranslation();

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="center-title">
                        <span className="sub-title">{t('story.subtitle')}</span>
                        <h2 className="h2-title">{t('story.title')}</h2>
                    </div>
                </div>

                <div className="col-lg-10">
                    <div className="story-list">
                        {milestones.map((m) => (
                            <div className="row align-items-center" key={m.year}>
                                {/* On desktop: alternate card left/right via order */}
                                <div className={`col-md-6 ${m.side === 'right' ? 'order-md-1 order-2' : 'order-md-2 order-2'}`}>
                                    <div className={`story-box ${m.side} ${m.color}`}>
                                        <span className="story-year-badge">{m.year}</span>
                                        <h3 className="h3-title">{t(`story.${m.titleKey}`)}</h3>
                                        <p>{t(`story.${m.descKey}`)}</p>
                                    </div>
                                </div>
                                {/* Year dot — kept for desktop center-line, hidden on mobile via existing CSS */}
                                <div className={`col-md-6 ${m.side === 'right' ? 'order-md-2 order-1' : 'order-md-1 order-1'}`}>
                                    <div className={`story-year ${m.side === 'right' ? 'left' : 'right'} ${m.color}`}>
                                        <h4 className="h4-title">{m.year}</h4>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StoryBlog;